function getUrlSuffix(msource: string) {
  return `?msource=${msource}`
}

// 初始化分享URL
export function makeShareUrl(msource: string) {
  const currentUrl = location.href.split('?')[0]
  return currentUrl + getUrlSuffix(msource)
}

// 初始化调起URL
// TODO： 需要按照活动实际情况调整调起时传入的数据
export function makeInvokeUrl(msource: string) {
  const currentUrl = location.href.split('?')[0]
  return currentUrl + getUrlSuffix(msource)
}
